import { ResetPasswordSubmitReq } from "domain/payload/request/forgot-password/ResetPasswordSubmitReq";
import { decryptPassword, encryptPassword } from "helpers/EncryptPassword";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AuthService from "service/AuthService";

const ResetPasswordPage: React.FC = () => {
  const [email, setEmail] = useState<string>("");
  const [sessionId, setSessionId] = useState<string>("");
  const [newPassword, setNewPassword] = useState<string>("");
  const [confirmPassword, setConfirmPassword] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const authService = AuthService();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    setEmail(decryptPassword(params.get("m")!) || "");
    setSessionId(params.get("sId") || "");
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (newPassword !== confirmPassword) {
      alert("Password tidak sama. Silakan periksa kembali.");
      return;
    }

    setIsLoading(true);
    try {
      const request: ResetPasswordSubmitReq = {
        email: encryptPassword(email),
        sessionId: encryptPassword(sessionId),
        newPassword: encryptPassword(newPassword),
      };

      await authService.resetPasswordSubmit(request);
      alert("Reset password berhasil!");
      navigate("/");
    } catch (err) {
      console.error(err);
      alert("Reset password gagal. Silakan coba lagi.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="container d-flex align-items-center justify-content-center vh-100">
      <div className="card shadow-sm p-4" style={{ maxWidth: 400, width: "100%" }}>
        <h4 className="text-center mb-4">Reset Password</h4>
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label htmlFor="email" className="form-label fw-bold">
              Email/Nomor Telepon
            </label>
            <input
              type="text"
              id="email"
              className="form-control"
              value={email}
              disabled
            />
          </div>

          <div className="mb-3">
            <label htmlFor="newPassword" className="form-label fw-bold">
              Password Baru
            </label>
            <input
              type="password"
              id="newPassword"
              className="form-control"
              placeholder="Masukkan password baru"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
            />
          </div>

          <div className="mb-4">
            <label htmlFor="confirmPassword" className="form-label fw-bold">
              Konfirmasi Password
            </label>
            <input
              type="password"
              id="confirmPassword"
              className="form-control"
              placeholder="Ulangi password baru"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
          </div>

          <button
            type="submit"
            className="btn btn-primary w-100 d-flex align-items-center justify-content-center"
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Mengubah...
              </>
            ) : (
              "Ubah Password"
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ResetPasswordPage;